export default "__VITE_ASSET__D4QCzESZ__"